var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.hasAnyRole("ROLE_ATMANAGE")
      ? _c(
          "div",
          { staticClass: "col-md-10 pt-3" },
          [
            _c("toast", { ref: "toast" }),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table table-bordered table-responsive" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.reportList, function(result, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.pagination.currentPage * _vm.dispMaxSize +
                              index +
                              1
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "noflap" }, [
                        _c("span", { staticClass: "noflap" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(result.companyName) +
                              "\n                   "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "noflap" }, [
                        _vm._v(_vm._s(result.domain))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(result.year) +
                            "年" +
                            _vm._s(result.month) +
                            "月"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(result.userCount))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(result.plan == 0 ? "ノーマル" : "エラー"))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("yen")(result.userCount * 100)) + "円"
                        )
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("No")]),
        _vm._v(" "),
        _c("th", [_vm._v("会社名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ドメイン")]),
        _vm._v(" "),
        _c("th", [_vm._v("対象年月")]),
        _vm._v(" "),
        _c("th", [_vm._v("今月契約数")]),
        _vm._v(" "),
        _c("th", [_vm._v("プラン")]),
        _vm._v(" "),
        _c("th", [_vm._v("請求（とりあえず100円計算）")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f09673c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f09673c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/atmanage/company/CompanyReportList.vue
// module id = 381
// module chunks = 0